<div class="container align-items-center">
  <div class="card-header" [ngStyle]="{ 'background-color': onderneming?.kleur }"></div>
  <div class="">
    <div class="row">
      <h1 class="col-10 cardHeader card-title text-left">
        <strong>Koopkrachtpremie</strong>
      </h1>
      <div class="col-2 text-right mt-2">
        <a class="backButton" [routerLink]="['/', onderneming.naam, 'tools']">
          <i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i>
        </a>
      </div>
    </div>

    <h6 class="card-subtitle mb-5 text-muted mobileTussentitel text-left">
      Bereken of u al dan niet een koopkrachtpremie moet betalen.
    </h6>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <label class="font-weight-bold" for="typeKoopkracht">Paritair comité</label>
          <select id="typeKoopkracht" formControlName="typeKoopkracht" class="form-control"
            (change)="onTypeKoopkrachtChange()">
            <option value="bouwbedrijf">
              124 Paritair comité voor het bouwbedrijf
            </option>
            <option value="bedienden">
              200 Aanvullend Paritair comité voor bedienden
            </option>
          </select>
        </div>
      </div>

      <hr class="separator" />
      <div *ngIf="form.value.typeKoopkracht === 'bouwbedrijf'">
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2019">Winst 2019:</label>
            <i placement="top" ngbTooltip="Code 9901 op uw jaarrekening. Indien er geen is winst, vul 0 in."
              tooltipClass="width-tooltip" class="fa size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"
              aria-hidden="true"></i>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2019" type="number"
                id="winst2019" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2020">Winst 2020:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2020" type="number"
                id="winst2020" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2021">Winst 2021:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2021" type="number"
                id="winst2021" />
            </div>
          </div>

          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2022">Winst 2022:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2022" type="number"
                id="winst2022" />
            </div>
          </div>
        </div>

        <hr class="separator" />

        <div *ngIf="form.value.typeKoopkracht === 'bouwbedrijf'">
          <h6 class="card-subtitle mb-2 mt-2 text-muted text-left mobileTussentitel">
            Een bijkomende voorwaarde is dat maximaal 15% van de winst van 2022
            gebruikt mag worden om uw premie uit te betalen.
          </h6>
          <div class="form-group col-md-6" style="padding-left: 0px !important">
            <!--Tooltip bij Co2 (momenteel niet dynamisch)-->
            <label class="font-weight-bold" for="co2Emissie">Aantal huidige werknemers:
              <i placement="top"
                ngbTooltip="Als bijkomende voorwaarde mag maximaal 15 % van de winst van 2022 gebruikt worden om deze premie uit te betalen."
                tooltipClass="width-tooltip" class="fa size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"
                aria-hidden="true"></i>
            </label>
            <input ng-valid min="0" class="form-control" formControlName="aantalWerknemers" type="number"
              id="aantalWerknemers" />
          </div>
        </div>
      </div>


      <div *ngIf="form.value.typeKoopkracht === 'bedienden'">
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="balanstotaal2019">Balanstotaal 2019:</label>
           
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="balanstotaal2019" type="number"
                id="balanstotaal2019" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2019">Winst 2019:</label>
            <i placement="top" ngbTooltip="Code 9901 op uw jaarrekening"
            tooltipClass="width-tooltip" class="fa size-tooltip-icon color-tooltip-icon fa-question-circle ml-1"
            aria-hidden="true"></i>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2019" type="number"
                id="winst2019" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="balanstotaal2020">Balanstotaal 2020:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="balanstotaal2020" type="number"
                id="balanstotaal2020" />
            </div>
          </div>

          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2020">Winst 2020:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2020" type="number"
                id="winst2020" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="balanstotaal2021">Balanstotaal 2021:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="balanstotaal2021" type="number"
                id="balanstotaal2021" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2021">Winst 2021:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2021" type="number"
                id="winst2021" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="font-weight-bold" for="balanstotaal2022">Balanstotaal 2022:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="balanstotaal2022" type="number"
                id="balanstotaal2022" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="font-weight-bold" for="winst2022">Winst 2022:</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">€</span>
              </div>
              <input ng-valid min="0" required class="form-control" formControlName="winst2022" type="number"
                id="winst2022" />
            </div>
          </div>
        </div>
      </div>

     

      <div class="row">
        <div class="col-md-12 mt-2">
          <div class="text-right">
            <button type="submit" [disabled]="!form.valid" class="btn btn-outline-secondary m-1">
              BEREKEN
            </button>
          </div>
        </div>
      </div>
    </form>

    <div class="row">
      <div class="col xMargin">
        <div *ngIf="!calculate" class="d-flex text-center w-100 h-100" style="min-width: auto; min-height: 6em">
          <div class="card-body d-flex align-items-center">
            <p class="placeholder text-center w-100">
              vul het formulier in om resultaat te krijgen.
            </p>
          </div>
        </div>
        <div *ngIf="calculate && form.value.typeKoopkracht === 'bouwbedrijf'">
          <div class="text-center w-100 h-100">
            <div class="kaderResultaat mt-4 mb-4">
              <h2 [ngStyle]="{ color: onderneming?.kleurKnoppen }" style="font-weight: bolder">
                Koopkrachtpremie
              </h2>
              <h2 class="mt-4">{{ basicResult | currency : "EUR" }}</h2>
            </div>
          </div>
          <div class="text-center w-100 h-100">
            <div class="kaderResultaat mt-4 mb-4">
              <h2 [ngStyle]="{ color: onderneming?.kleurKnoppen }" style="font-weight: bolder">
                Koopkrachtpremie met beperking tot 15% van de winst van 2022
              </h2>
              <h2 class="mt-4">{{ advancedResult | currency : "EUR" }}</h2>
            </div>
          </div>
        </div>
        <div *ngIf="calculate && form.value.typeKoopkracht === 'bedienden'">
          <div class="text-center w-100 h-100">
            <div class="kaderResultaat mt-4 mb-4">
              <h2 [ngStyle]="{ color: onderneming?.kleurKnoppen }" style="font-weight: bolder">
                Koopkrachtpremie
              </h2>
              <h2 class="mt-4">{{ basicResult | currency : "EUR" }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border-top"></div>

    <div class="card-bottom col-12 mobile" [ngStyle]="{ 'background-color': onderneming?.kleur }"></div>
    <div class="mt-4 row h-100">
      <p class="text-center mx-auto font-italic">
        {{ dataService.onderneming?.algemeneWaarschuwing }}
      </p>
    </div>
  </div>

  <!-- </div> -->
</div>